export const timesheetEndpoints = {
    filter: "/api/WorkReport/Filter", // Fetch timesheets with filters
    getById: (id: number) => `/api/WorkReport/${id}`, // Fetch a timesheet by ID
    insert: "/api/WorkReport/Insert", // Insert a new timesheet
    bulkInsert: "/api/WorkReport/BulkInsert", // Bulk insert timesheets
    update: (id: number) => `/api/WorkReport/Update?id=${id}`, // ✅ Match Angular (uses query param `?id=`)
    delete: (id: number) => `/api/WorkReport/Delete?id=${id}`, // ✅ Match Angular (uses query param `?id=`)
    addNote: "/api/WorkReportNote/Insert", // Add a note to a work report
};
